/**
 * Navigation Metrics
 * Leverages @rei/metrics instance - currently initialized in the footer.js (from monolith)
 * Stop-gap until new implementation of analytics and/or @rei/metrics is finalized.
 */
import { anchorOrButtonEvents, inputEvents } from '@rei/click-event-pubsub';

// check if the user is closing an open menu
const hasBeenClickedMap = new Set();
const hasBeenClicked = (linkName) => {
  if (hasBeenClickedMap.has(linkName)) {
    return true;
  }

  hasBeenClickedMap.add(linkName);
  return false;
};

/**
 * Assumes the subscriber element has a 'data-analytics-id' attribute, and uses this to build
 * the analytics config (aka linkName). Then triggers metrics.link with that config.
 *
 * The package `@rei/search-input-suggestions` may optionally add a
 * `data-analytics-eligible-tests` attribute to the subscriber element.
 * This attribute contains information about the experiment or A/B test
 * the user is currently enrolled in (e.g. when the user is in the
 * autosuggest experience that displays products).
 *
 * If present and valid, this value will be included in the metrics.link
 * payload as `analyticsEligibleTests`.
 *
 * @param navElem - A single common-component or section of the DOM used to limit scope.
 * @param e - Click event.
 * @param subscriber - Anchor, button, or input element subscribed to a click event.
 */
export const analyticsClickHandler = (navElem, e, subscriber) => {
  const { metrics } = window;

  if (metrics && navElem.contains(subscriber)) {
    const linkName = subscriber?.dataset?.analyticsId;
    const eligibleTests = subscriber?.dataset?.analyticsEligibleTests;

    if (!hasBeenClicked(linkName) && linkName !== 'rei_nav:' && typeof linkName !== 'undefined') {
      const payload = { linkName };

      if (typeof eligibleTests === 'string' && eligibleTests.trim().length > 0) {
        payload.eligibleTests = eligibleTests;
      }

      metrics.link(payload, e);
    }
  }
};

/**
 * Triggers metrics.link using a customConfig object. Mainly used for tracking analytics
 * on markup generated by JavaScript. Ex. the search box - auto-suggest and most recent searches.
 * @param {object} customConfig
 */
export const analyticsCustomClickHandler = (customConfig) => {
  const { metrics } = window;
  if (metrics) {
    metrics.link(customConfig);
  }
};

const init = (navSelector = null) => {
  const navElem = document.querySelector(navSelector);
  /* Exit if navSelector is not found */
  if (navElem === null) {
    return;
  }
  anchorOrButtonEvents.push(analyticsClickHandler.bind(null, navElem));
  /* inputEvents for search box */
  inputEvents.push(analyticsClickHandler.bind(null, navElem));
};
export default init;
